import { useEffect, useRef } from 'react';

// thanks: https://overreacted.io/making-setinterval-declarative-with-react-hooks/

type voidFunc = () => void;
export default function useInterval(callback: voidFunc, delay: number) {
    const savedCallback = useRef<voidFunc|undefined>();

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}